const js = {
  injectStripeDependency (document) {
    if (!js.isStripeLoaded(document)) {
      let head = document.getElementsByTagName('head')[0]
      let stripeScr = document.createElement('script')
      stripeScr.src = 'https://js.stripe.com/v3/'
      stripeScr.id = 'vue-stripe-js-v3'
      stripeScr.defer = true
      stripeScr.async = true
      head.appendChild(stripeScr)
    }
  },
  awaitStripe () {
    return new Promise(function (resolve, reject) {
      let check = (i) => {
        if (js.isStripeLoaded()) {
          // console.log('resolving!')
          resolve()
        } else {
          if (i < 10) {
            setTimeout(() => check(i++), 300)
          } else {
            reject(new Error('Stripe.js did not load in a timely fashion. Please try again later.'))
          }
        }
      }
      let i = 0
      check(i)
    })
  },
  isStripeLoaded () {
    let result = 'Stripe' in window
    // console.log(`stripe loaded? ${result}`)
    return result
  }
}

export default {
  js
}